const INIT_STATE = {
  loading: false,
  error: false,
  errorMessage: null,
  list: [],
  item: null,
  action: null
};

const reducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case 'GET_COMPARE_VARIABLES':
      return { ...state, loading: true, error: false, errorMessage: null, action: null, list: [] };

    case 'GET_COMPARE_VARIABLES_SUCCESS':
      return { ...state, loading: false, error: false, errorMessage: null, list: action.payload.data, action: null };

    case 'GET_COMPARE_VARIABLES_FAILED':
      return { ...state, loading: false, error: true, errorMessage: action.payload.message, action: null };

    case 'GET_COMPARE_VARIABLE':
      return { ...state, loading: true, error: false, action: null, item: null };

    case 'GET_COMPARE_VARIABLE_SUCCESS':
      return { ...state, loading: false, error: false, item: action.payload.data, action: null };

    case 'GET_COMPARE_VARIABLE_FAILED':
      return { ...state, loading: false, error: true, errorMessage: action.payload.message, action: null };

    case 'CREATE_COMPARE_VARIABLE':
      return { ...state, loading: true, error: false, action: null }

    case 'CREATE_COMPARE_VARIABLE_SUCCESS':
      return { ...state, loading: false, error: false, action: 'CREATED', item: action.payload.data }

    case 'CREATE_COMPARE_VARIABLE_FAILED':
      return { ...state, loading: false, error: true, errorMessage: action.payload.message, action: null }

    case 'UPDATE_COMPARE_VARIABLE':
      return { ...state, loading: true, error: false, action: null }

    case 'UPDATE_COMPARE_VARIABLE_SUCCESS':
      return { ...state, loading: false, error: false, action: 'UPDATED', item: action.payload.data }

    case 'UPDATE_COMPARE_VARIABLE_FAILED':
      return { ...state, loading: false, error: true, errorMessage: action.payload.message, action: null }

    case 'DELETE_COMPARE_VARIABLE':
      return { ...state, loading: true, action: null }

    case 'DELETE_COMPARE_VARIABLE_SUCCESS':
      return { ...state, loading: false, error: false, action: 'DELETED' }

    case 'DELETE_COMPARE_VARIABLE_FAILED':
      return { ...state, loading: false, error: true, errorMessage: action.payload.message, action: null }

    default:
      return state;

  }
};

export default reducer;